import type { ZapEHRClientRequest } from './client/client';
import { setConfig } from './config';
import * as fhirUtils from './fhir';
import * as resources from './resources';

export default {
  ...resources,
  ...fhirUtils,
  init: setConfig,
};

export * from './errors';
export * from './resources/fhir/types';

export type { ZapEHRClientRequest };
